module.exports = __webpack_public_path__ + "static/media/art11.c210fce5.png";